/* Native sorting preserves the customer's current search and filters. */
(() => {
  if (window.FDMListingSortInstalled) return;
  window.FDMListingSortInstalled = true;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[data-fdm-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
})();
